<template>
    <div class="tsa-list">
        <table>
            <thead>
                <slot></slot>
            </thead>
            <tbody>
                <tr v-for="item in data" :key="item.id">
                    <td v-for="column in tableColumns" :key="column.prop">
                        {{ item[column.prop] }}
                    </td>
                    <!-- <td>{{ index + 1 }}</td>
                    <td>{{ item["date"] }}</td>
                    <td>{{ item["name"] }}</td>
                    <td>{{ item["address"] }}</td> -->
                </tr>
                <!-- <tr v-for="(item, index) in data" :key="index">
                    <slot name="row" :row="item" :index="index"></slot>
                </tr> -->
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        // 1.从slot中获取prop和label
        tableColumns() {
            const columns = [];
            if (this.$slots.default) {
                this.$slots.default.forEach((vnode) => {
                    console.info(vnode)
                if (vnode.componentOptions && vnode.componentOptions.propsData) {
                    const { prop, label } = vnode.componentOptions.propsData;
                    const slot = vnode.componentInstance.$scopedSlots.default;
                    columns.push({ prop, label, });
                }
                });
            }
            console.error(columns)
            return columns;
        },
    },
    data () {
        return {
            headerList: [],
        }
    },
    mounted () {
        // console.log(this.$children)
        // this.$children.map((item) => {
        //     console.log(this.$scopedSlots.default)
        //     this.headerList.push({
        //         ...item.$attrs,
        //         slot: item.$scopedSlots.default ? item.$scopedSlots.default({row: item.$attrs}) : ''
        //     })
        // })
    }
}
</script>

<style lang="scss" scoped>
    .tsa-list {
        table {
            width: 100%;
            border-collapse: collapse;
            table-layout: fixed;
            thead {
                tr {
                    th {
                        border: 1px solid #ccc;
                        padding: 10px;
                    }
                }
            }
            tbody {
                tr {
                    td {
                        border: 1px solid #ccc;
                        padding: 10px;
                    }
                }
            }
        }
    }
</style>